import { render, staticRenderFns } from "./SelectProductionToLose.vue?vue&type=template&id=2ddb0ea3"
import script from "./SelectProductionToLose.vue?vue&type=script&lang=ts"
export * from "./SelectProductionToLose.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports